import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  loadComparisonPortalAll,
  loadComparisonPortalCategoriesAll,
  saveComparisonPortalCategory,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(loadComparisonPortalCategoriesAll.type, send, socket);
  yield takeEvery(loadComparisonPortalAll.type, send, socket);
  yield takeEvery(saveComparisonPortalCategory.type, send, socket);
}
